const images = {
  sievaLogo: require("../assets/images/sieva-logo.png"),
};

export default images;
